/* tslint:disable */
/* eslint-disable */
/**
 * EcoCerram API
 * EcoCerram API generated from BE
 *
 * The version of the OpenAPI document: 0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Certificate
 */
export interface Certificate {
    /**
     * 
     * @type {string}
     * @memberof Certificate
     */
    languageCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Certificate
     */
    fileName?: string;
}

/**
 * Check if a given object implements the Certificate interface.
 */
export function instanceOfCertificate(value: object): value is Certificate {
    return true;
}

export function CertificateFromJSON(json: any): Certificate {
    return CertificateFromJSONTyped(json, false);
}

export function CertificateFromJSONTyped(json: any, ignoreDiscriminator: boolean): Certificate {
    if (json == null) {
        return json;
    }
    return {
        
        'languageCode': json['languageCode'] == null ? undefined : json['languageCode'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
    };
}

export function CertificateToJSON(json: any): Certificate {
    return CertificateToJSONTyped(json, false);
}

export function CertificateToJSONTyped(value?: Certificate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'languageCode': value['languageCode'],
        'fileName': value['fileName'],
    };
}

